import openWindow from '@/script/openWindow.mjs'
import {useMapContext} from '@/components/MindMap/index.mjs'

export default () => {
    const map = useMapContext()
    const {mapTypeCode, prjPatternId} = map.data

    if (! (prjPatternId && 'SA_MAP' === mapTypeCode)) {
        return null
    }

    const onClick = () => openWindow('/WorkloadBdlogic', {prjPatternId})

    return {
        key: 'workflow-by-bdlogic',
        label: '查看程序能力工作量清单',
        onClick,
    }
}
